<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (aiAvailable) {
      <div class="ai-actions">
        <pr-button
          display="neutral"
          variant="outline"
          label="Générer par IA"
          (onClick)="generateWithAi()"
        />
      </div>
    }
    <div class="formControl mt">
      <app-froala-editor
        formControlName="recommandationRcda"
        [toolbarButtons]="toolbarButtons"
      ></app-froala-editor>
    </div>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
